module.exports = __webpack_public_path__ + "static/media/1-xs.c76dd8d1.jpg";